import { FloatingMenu } from '@agilize/components-core';
import styled, { css } from 'styled-components';
import { minWidth, height, maxWidth, maxHeight, minHeight } from 'styled-system';

export const ButtonTitle = styled.div`
  font-weight: 500;
  font-size: ${props => props.theme.fontSizes[2]};
  color: ${props => props.theme.colors.grey700};
  margin-left: ${props => props.theme.global.gutterSpace * 0.75}px;
`;

export const StyledFloatingMenuButton = styled(FloatingMenu)`
  ${maxHeight};
  ${minHeight}
  ${minWidth};
  ${height};
  ${maxWidth};
  display: flex;
  align-items: center;
  padding: ${props => props.theme.global.gutterSpace * 0.625}px ${props => props.theme.global.gutterSpace}px;
  border-radius: ${props => props.theme.forms.borderRadius * 1.5}px;

  &:active {
    border-color: red;
    & > div {
      color: ${props => props.theme.colors.grey900};
    }
  }
  &:hover {
    & > div {
      color: ${props => props.theme.colors.grey900};
    }
    & > svg {
      fill: ${props => props.theme.colors.grey700};
    }
    border-color: transparent;
    background-color: ${props => props.theme.colors.white};
  }
  ${props =>
    props.isOpen &&
    css`
      border: transparent;
      background-color: ${props => props.theme.colors.grey200};
      & > div {
        color: ${props => props.theme.colors.purple700};
      }
    `}
  ${props =>
    !props.disabled &&
    css`
      cursor: pointer;
    `}
    ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`;

export const ZendeskButton = styled.div``;
